(function (root) {
  'use strict';
  var V = root.Vantor;
  var EMPTY = { truck: null, bed: null, notice: null, cleared: false };
  var BED_VALUE = /^\d{1,2}(\.\d)?$/;
  var UNAVAILABLE = "The Cap isn't available right now.";

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }
  function truckOf(id) { return V.CATALOG.trucks.find(function (t) { return t.id === id; }) || null; }
  function bedOf(truck, id) { return truck ? truck.beds.find(function (b) { return b.id === id; }) || null : null; }
  function bandOf(bed) { return V.CATALOG.cap.lengths.find(function (l) { return l.id === bed.length; }); }
  function nameOf(truck) { return truck.make + ' ' + truck.model; }
  function joinLabels(labels) {
    return labels.length < 2 ? labels.join('') : labels.slice(0, -1).join(', ') + ' and ' + labels[labels.length - 1];
  }
  function onlyBed(truck) { return truck.beds.length === 1 ? truck.beds[0].id : null; }

  function fromQuery(search) {
    var q = new URLSearchParams(search), tv = q.get('truck'), bv = q.get('bed');
    if (tv === null) return EMPTY;
    var truck = truckOf(tv);
    if (!truck) return { truck: null, bed: null, notice: "We don't recognise that truck. Pick yours from the list.", cleared: false };
    if (bv === null) return { truck: truck.id, bed: onlyBed(truck), notice: null, cleared: false };
    if (bedOf(truck, bv)) return { truck: truck.id, bed: bv, notice: null, cleared: false };
    var bed = BED_VALUE.test(bv) ? 'a ' + bv + ' ft bed' : 'that bed length';
    return { truck: truck.id, bed: null, notice: "We don't have " + bed + ' listed for the ' + nameOf(truck) + '. Pick one of its bed lengths, or clear to start over.', cleared: false };
  }

  function reduce(state, ev) {
    if (ev.type === 'query') return fromQuery(ev.search);
    if (ev.type === 'clear') return EMPTY;
    if (ev.type === 'bed') return bedOf(truckOf(state.truck), ev.id) ? { truck: state.truck, bed: ev.id, notice: null, cleared: false } : state;
    if (ev.type === 'truck') {
      var truck = truckOf(ev.id);
      if (!truck || truck.id === state.truck) return state;
      var only = onlyBed(truck);
      return { truck: truck.id, bed: only, notice: null, cleared: !!state.bed && !only };
    }
    return state;
  }

  function query(state) {
    var q = [];
    if (state.truck) q.push('truck=' + encodeURIComponent(state.truck));
    if (state.bed) q.push('bed=' + encodeURIComponent(state.bed));
    return q.join('&');
  }

  function capOnlyOffers(truck, bed) {
    var fitment = V.fitmentOf(truck.id, bed.id);
    return V.CATALOG.cap.windows.map(function (w) {
      var o = V.offerOf(V.variantFor('cap', { fitment: fitment, window: w.id, storage: false }));
      return o ? { win: w, offer: o, state: o.state } : null;
    }).filter(Boolean);
  }
  function labels(xs) { return xs.map(function (x) { return x.win.label; }).join(' and '); }
  function everyWindow(all) { return all.length === V.CATALOG.cap.windows.length; }

  function pills(o) {
    if (o.state === 'out') return '<span class="pill pill--muted">Sold out</span>';
    if (o.state === 'in') return '<span class="pill pill--stock">In stock</span>';
    if (!(o.due > 0)) return '<span class="pill pill--presale">Back-order</span>';
    return '<span class="pill pill--presale">Presale</span><span class="pill pill--presale">' + V.money(o.due) + ' deposit</span>' +
      (o.savings > 0 ? '<span class="pill pill--deal">' + V.money(o.savings) + ' off</span>' : '');
  }

  function terms(o, all) {
    if (o.state === 'out') {
      var open = all.filter(function (x) { return x.state !== 'out'; });
      if (open.length) return open[0].win.label + ' is available for this bed.';
      return everyWindow(all) ? 'Sold out in every window for this bed.' : 'Sold out for this bed.';
    }
    if (o.state === 'in') return 'In stock. Pay in full at checkout.';
    return 'Preorder: ' + V.money(o.total) + (o.savings > 0 ? ' after ' + V.money(o.savings) + ' off' : '') + '. ' +
      V.money(o.due) + ' deposit today, ' + V.money(o.rem) + ' balance online before dispatch.';
  }

  function tile(x, all, truck, bed, page) {
    var o = x.offer;
    var action = x.state === 'out' ? '' :
      '<a class="btn btn--block sbt-tile__go" href="' + esc(page.builderUrl + '?truck=' + encodeURIComponent(truck.id) + '&bed=' + encodeURIComponent(bed.id) + '&window=' + x.win.id) + '">Configure ' + esc(x.win.label) + '</a>';
    return '<li class="sbt-tile" data-window="' + x.win.id + '" data-state="' + x.state + '">' +
      '<div class="sbt-tile__head"><h4 class="sbt-tile__name">' + esc(x.win.label) + '</h4><p class="sbt-tile__price">' + V.money(o.list) + '</p></div>' +
      '<div class="pill-row">' + pills(o) + '</div>' +
      '<p class="sbt-tile__terms">' + esc(terms(o, all)) + '</p>' + action + '</li>';
  }

  function windowsLine(all) {
    var out = all.filter(function (x) { return x.state === 'out'; });
    var open = all.length - out.length;
    if (!open) return everyWindow(all) ? 'Sold out in every window.' : labels(out) + ' is sold out.';
    return (open === 1 ? 'One window choice.' : 'Two window choices.') + (out.length ? ' ' + labels(out) + ' is sold out.' : '');
  }

  function view(state, page) {
    var truck = truckOf(state.truck), bed = bedOf(truck, state.bed);
    var band = bed ? bandOf(bed) : null;
    var all = bed && !page.collectionEmpty ? capOnlyOffers(truck, bed) : [];
    var legend = '<legend class="visually-hidden">Bed length</legend>';
    var beds = !truck ? legend + '<span class="seg__hint">Select a truck first</span>' : legend + truck.beds.map(function (b) {
      return '<label class="seg__opt"><input type="radio" name="bed" value="' + esc(b.id) + '"' + (b.id === state.bed ? ' checked' : '') + '>' +
        '<span class="seg__face">' + esc(b.label) + ' bed<small>Cap ' + esc(bandOf(b).label) + '</small></span></label>';
    }).join('');
    var bedNote = truck && truck.beds.length === 1 ? truck.model + ' comes in one bed length.' : '';

    var result, line = '';
    if (!truck) {
      result = '<div class="sbt-empty"><p class="sbt-empty__title">Your Cap shows here.</p><ul class="sbt-bands" role="list">' +
        V.CATALOG.cap.lengths.map(function (l) {
          return '<li><span class="sbt-bands__band">Cap ' + esc(l.label) + '</span><span class="sbt-bands__fits">' + esc(l.fits) + '</span></li>';
        }).join('') + '</ul></div>';
    } else if (!bed) {
      result = '<div class="sbt-empty"><p class="sbt-empty__title">Choose a bed length for the ' + esc(nameOf(truck)) + '.</p></div>';
    } else if (!all.length) {
      line = UNAVAILABLE;
      result = '<div class="sbt-empty"><p class="sbt-empty__title">' + esc(line) + '</p>' +
        '<a class="textlink" href="' + esc(page.contactUrl) + '">Contact us <span aria-hidden="true">&rarr;</span></a></div>';
    } else {
      line = 'Cap ' + band.label + ' fits the ' + nameOf(truck) + ' ' + bed.label + ' bed. ' + windowsLine(all);
      result = '<div class="sbt-fit"><p class="kicker sbt-fit__eyebrow">Fits your truck</p>' +
        '<h3 class="sbt-fit__title" translate="no">' + esc(V.CATALOG.cap.full) + '</h3>' +
        '<dl class="sbt-fit__facts"><div><dt>Truck</dt><dd>' + esc(nameOf(truck)) + ' · ' + esc(bed.label) + ' bed</dd></div>' +
        '<div><dt>Cap size</dt><dd>' + esc(band.label) + '</dd></div></dl>' +
        '<ul class="sbt-tiles" role="list">' + all.map(function (x) { return tile(x, all, truck, bed, page); }).join('') + '</ul>' +
        '<a class="textlink" href="' + esc(V.shopRaw.products.cap.url) + '">Cap details <span aria-hidden="true">&rarr;</span></a>' +
        '<p class="faint sbt-fit__note">Price shown is this exact size and window. Add-ons are chosen in the Builder.</p></div>';
    }
    var valid = all.length > 0;
    var status = state.notice || (state.cleared ? 'Bed length cleared. ' + truck.model + ' comes in ' + joinLabels(truck.beds.map(function (b) { return b.label; })) + '.' : '') || line;
    var n = page.productsCount;
    return {
      truck: truck ? truck.id : null, beds: beds, bedNote: bedNote, status: status, result: result,
      clear: !!truck, gridNote: !!truck && n > 0, capHidden: valid,
      count: n + (n === 1 ? ' product' : ' products') + (valid ? ' · Your Cap is above' : ''),
      notice: !!state.notice
    };
  }

  root.VantorShopByTruck = { EMPTY: EMPTY, reduce: reduce, view: view, query: query };

  var page = V.catalogPage;
  if (!page || typeof document === 'undefined' || !document.querySelector) return;
  var panel = document.querySelector('[data-sbt]');
  if (!panel) return;
  var $ = function (s) { return panel.querySelector(s); };
  var state = reduce(EMPTY, { type: 'query', search: location.search });
  var paintedFor;

  function paint() {
    var p = view(state, page);
    panel.querySelectorAll('input[name="truck"]').forEach(function (i) { i.checked = i.value === p.truck; });
    if (paintedFor !== p.truck) { $('[data-sbt-beds]').innerHTML = p.beds; paintedFor = p.truck; }
    panel.querySelectorAll('input[name="bed"]').forEach(function (i) { i.checked = i.value === state.bed; });
    var note = $('[data-sbt-bednote]');
    note.textContent = p.bedNote;
    note.hidden = !p.bedNote;
    var status = $('[data-sbt-status]');
    if (status.textContent !== p.status) status.textContent = p.status;
    status.classList.toggle('sbt__status--notice', p.notice);
    $('[data-sbt-result]').innerHTML = p.result;
    $('[data-sbt-clear]').hidden = !p.clear;
    document.querySelectorAll('[data-sbt-count]').forEach(function (n) { n.textContent = p.count; });
    document.querySelectorAll('[data-sbt-gridnote]').forEach(function (n) { n.hidden = !p.gridNote; });
    document.querySelectorAll('[data-sbt-cap]').forEach(function (n) { n.hidden = p.capHidden; });
  }

  function write() {
    var q = new URLSearchParams(location.search);
    q.delete('truck');
    q.delete('bed');
    var rest = q.toString(), own = query(state);
    var search = [own, rest].filter(Boolean).join('&');
    history.replaceState(history.state, '', location.pathname + (search ? '?' + search : '') + location.hash);
  }

  panel.addEventListener('change', function (e) {
    var t = e.target;
    if (t.name !== 'truck' && t.name !== 'bed') return;
    state = reduce(state, { type: t.name, id: t.value });
    paint();
    write();
  });
  $('[data-sbt-clear]').addEventListener('click', function () {
    state = reduce(state, { type: 'clear' });
    paint();
    write();
    panel.querySelector('input[name="truck"]').focus();
  });
  paint();
})(window);
